import { render, staticRenderFns } from "./investmentClues1.vue?vue&type=template&id=2bb7772c&"
import script from "./investmentClues1.vue?vue&type=script&lang=js&"
export * from "./investmentClues1.vue?vue&type=script&lang=js&"
import style0 from "./investmentClues1.vue?vue&type=style&index=0&lang=css&"
import style1 from "./investmentClues1.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports